import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogParceiro = ({ list, onClose, ...props }) => {
    const form = useFormik({
        initialValues: {
            clienteId: undefined
        },
        validationSchema: yup.object({
            clienteId: yup.number().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values.clienteId);
        }
    });
    console.log(form);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Selecionar parceiro da lista</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label={`Cliente`} required name='clienteId' defaultValue={form.values?.clienteId} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.clienteId && Boolean(form.errors.clienteId)} helperText={form.touched.clienteId && form.errors.clienteId} select>
                <MenuItem value='' disabled>
                  Escolha uma opção da lista
                </MenuItem>
                {list.map(r => {
            return (<MenuItem key={r.id} value={r.id}>
                      {r.nome}
                    </MenuItem>);
        })}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogParceiro;
